import * as http from '@/api/config';

/* 获取调查 */
export function getAdminSurveyList(data) {
    const url = 'survey/admin/v1/survey/list';
    return http.$get(url, data);
}
/* 调查详情 */
export function getAdminSurveyInfo(uuid) {
    const url = 'survey/admin/v1/survey/info/' + uuid;
    return http.$get(url);
}
/* 获取调查的微信小程序Qr */
export function getSurveyWechatQr(id) {
    const url = 'survey/admin/v1/survey/wechat_qr/' + id;
    return http.$get(url);
}
/* 新增调查 */
export function createAdminSurvey(data) {
    const url = 'survey/admin/v1/survey/create';
    return http.$post(url, data);
}
/* 编辑调查 */
export function updateAdminSurveyBaseMessage(uuid, data) {
    const url = 'survey/admin/v1/survey/update/' + uuid;
    return http.$put(url, {
        ...data,
        type: 'base',
    });
}
/* 编辑调查内容 */
export function updateAdminSurveyContent(uuid, content) {
    const url = 'survey/admin/v1/survey/update/' + uuid;
    return http.$put(url, {
        content: content,
        type: 'content',
    });
}

/* 关闭调查 */
export function closeAdminSurvey(uuid) {
    const url = 'survey/admin/v1/survey/close/' + uuid;
    return http.$put(url);
}

/* 发布调查 */
export function publishAdminSurvey(uuid) {
    const url = 'survey/admin/v1/survey/publish/' + uuid;
    return http.$put(url);
}
/* 复制调查 */
export function copyAdminSurvey(uuid) {
    const url = 'survey/admin/v1/survey/copy/' + uuid;
    return http.$post(url);
}
/* 置顶调查 */
export function setAdminSurveyTop(uuid) {
    const url = 'survey/admin/v1/survey/top/' + uuid;
    return http.$put(url, {
        value: 1,
    });
}
/* 取消置顶调查 */
export function cancelAdminSurveyTop(uuid) {
    const url = 'survey/admin/v1/survey/top/' + uuid;
    return http.$put(url, {
        value: 0,
    });
}
/* 删除调查 */
export function deleteAdminSurvey(uuid) {
    const url = 'survey/admin/v1/survey/delete/' + uuid;
    return http.$delete(url);
}
/* 获取我的调查 */
export function getMineSurvey(data) {
    const url = 'survey/home/v1/survey/mine';
    return http.$get(url, data);
}
/* 获取调查详情 */
export function getHomeSurveyInfo(uuid) {
    const url = 'survey/home/v1/survey/info/' + uuid;
    return http.$get(url);
}
/* 获取问卷 */
export function getAdminSurveyPaperList(data) {
    const url = 'survey/admin/v1/paper/list';
    return http.$get(url, data);
}
/* 创建问卷 */
export function createAdminSurveyPaper(data) {
    const url = 'survey/admin/v1/paper/create';
    return http.$post(url, data);
}
/* 获取问卷详情 */
export function getAdminSurveyPaperInfo(uuid) {
    const url = 'survey/admin/v1/paper/info/' + uuid;
    return http.$get(url);
}
/* 更新问卷 */
export function updateAdminSurveyPaperBaseMessage(uuid, data) {
    const url = 'survey/admin/v1/paper/update/' + uuid;
    return http.$put(url, {
        ...data,
        type: 'base',
    });
}
/* 更新问卷题目 */
export function updateAdminSurveyPaperQuestion(uuid, data) {
    const url = 'survey/admin/v1/paper/update/' + uuid;
    return http.$put(url, {
        type: 'question',
        question: data,
    });
}
/* 关闭问卷 */
export function closeAdminSurveyPaper(uuid) {
    const url = 'survey/admin/v1/paper/close/' + uuid;
    return http.$put(url);
}

/* 发布问卷 */
export function publishAdminSurveyPaper(uuid) {
    const url = 'survey/admin/v1/paper/publish/' + uuid;
    return http.$put(url);
}
/* 复制问卷 */
export function copyAdminSurveyPaper(uuid) {
    const url = 'survey/admin/v1/paper/copy/' + uuid;
    return http.$post(url);
}
/* 置顶问卷 */
export function setAdminSurveyPaperTop(uuid) {
    const url = 'survey/admin/v1/paper/top/' + uuid;
    return http.$put(url, {
        value: 1,
    });
}
/* 取消置顶问卷 */
export function cancelAdminSurveyPaperTop(uuid) {
    const url = 'survey/admin/v1/paper/top/' + uuid;
    return http.$put(url, {
        value: 0,
    });
}
/* 删除问卷 */
export function deleteAdminSurveyPaper(uuid) {
    const url = 'survey/admin/v1/paper/delete/' + uuid;
    return http.$delete(url);
}
/* 获取问卷分类列表 */
export function getAdminSurveyPaperCateList() {
    const url = 'survey/admin/v1/paper_category/list';
    return http.$get(url);
}
/* 获取问卷分类下级列表 */
export function getAdminSurveyPaperCateChild(uuid) {
    const url = 'survey/admin/v1/paper_category/child/' + uuid;
    return http.$get(url);
}
/* 新增问卷分类 */
export function createAdminSurveyPaperCate(data) {
    const url = 'survey/admin/v1/paper_category/create';
    return http.$post(url, data);
}
/* 获取问卷分类详情 */
export function getAdminSurveyPaperCateInfo(uuid) {
    const url = 'survey/admin/v1/paper_category/info/' + uuid;
    return http.$get(url);
}
/* 编辑问卷分类 */
export function updateAdminSurveyPaperCate(uuid, data) {
    const url = 'survey/admin/v1/paper_category/update/' + uuid;
    return http.$put(url, data);
}
/* 排序问卷分类 */
export function sortAdminSurveyPaperCate(data) {
    const url = 'survey/admin/v1/paper_category/sort';
    return http.$post(url, data);
}
/* 删除问卷分类 */
export function deleteAdminSurveyPaperCate(uuid) {
    const url = 'survey/admin/v1/paper_category/delete/' + uuid;
    return http.$delete(url);
}




// WEBPACK FOOTER //
// ./src/api/module/survey.js